// Efeitos colaterais de storeByUser, retirados do reducer.
//
// A gravação em localStorage e o window.location.reload(false) viviam dentro de um
// `produce`, o que tornava o reducer impuro e disparava a navegação no meio do dispatch.
//
// O reload continua existindo, e por decisão: os três chamadores vivos de setStore
// (SelectStoreModal, o "limpar" da barra superior e o modal de itens sem estoque) contam
// com ele para o restante da aplicação refletir a nova farmácia. As vitrines também
// observam storeByUser.data e refazem suas consultas, mas o reload preserva o contrato dos
// fluxos de seleção manual. O contexto de entrega usa SET_RESOLVED_STORE e não recarrega a
// página inteira.

import { put } from "redux-saga/effects";

import { SELECTED_STORE_KEY } from "../ducks/storeByUser";
import { Creators as DeliveryContextActions } from "../ducks/deliveryContext";

export function* persistSelectedStore({ payload }) {
  const { store, reload } = payload;

  try {
    if (store) {
      localStorage.setItem(SELECTED_STORE_KEY, JSON.stringify(store));
    } else {
      // Antes gravava a string "null", que continuava ocupando a chave. Remover é o que o
      // logout e a leitura síncrona do INITIAL_STATE esperam.
      localStorage.removeItem(SELECTED_STORE_KEY);
    }
  } catch (_) {
    // Modo privativo ou cota estourada: a escolha vale em memória nesta sessão.
  }

  // Travar e destravar a farmácia é a mesma ação, vista pelo contexto.
  const farmacia = store
    ? { id: store.id, uuid: store.uuid, nome_fantasia: store.nome_fantasia }
    : null;
  yield put(DeliveryContextActions.setLockedPharmacy(farmacia));

  if (reload) {
    window.location.reload(false);
  }
}
